import { render, staticRenderFns } from "./FilterPosts.vue?vue&type=template&id=185dc6ac&"
import script from "./FilterPosts.vue?vue&type=script&lang=js&"
export * from "./FilterPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports